var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-nav-list"},[_c('ul',{staticClass:"nav-root"},[(_vm.user.uid)?[_c('li',[_c('router-link',{attrs:{"to":"/app/shelf"}},[_vm._v(_vm._s(_vm.$t('header.navShelf')))])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/app/orders"}},[_vm._v(_vm._s(_vm.$t('header.navOrder')))])],1)]:_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }